import { toast } from 'react-toastify';
import history from 'services/history';
import { isNumericId } from 'utils/numericId';

export function navigateToProntuario(codpac, state) {
  if (!isNumericId(codpac)) {
    toast.error('Paciente sem código válido para abrir o prontuário.');
    return false;
  }

  const path = `/prontuario/${String(codpac).trim()}`;
  if (state !== undefined) {
    history.push(path, state);
  } else {
    history.push(path);
  }
  return true;
}
